import { Button } from "antd";
import {
  capitalize,
  CurrencyFormat,
  formatDate,
} from "../../../../components/helpers";
import { AiFillEye } from "react-icons/ai";
import moment from "moment";
import { convertStatus, convertStatusInstallment } from "../../../customer/helpers/convertStatusGadai";

export const convertGadaiReportDetail = (
  detail,
  handleOpenPreview,
  handleOpenCampignDetail
) => {
  console.log('detail', detail)
  if (!detail) {
    return null;
  }
  let convertedGadaiDetail = {};
  convertedGadaiDetail = {
    id: detail.gadai_detail.id,
    commonInfo: {
      id: detail.customer.id,
      productCategory: detail.gadai_detail.product_category,
      dueDate: formatDate(detail.gadai_detail.due_date) || "-",
      paymentType: detail.gadai_detail.payment_type
    },
    headerInfo: {
      customerName: detail.customer.ktp_name || "-",
      customerEmail: detail.customer.email || "-",
      customerPicture: detail.customer.customer_picture || null,
      customerPhone1: detail.customer.phone_1 || "-",
      customerPhone2: detail.customer.phone_2 || "-",
      sbgCode: detail.gadai_detail.sbg_code || "-",
      receiptNumber: detail.gadai_detail.receipt_code || "-",
      outletName: detail.gadai_detail.outlet_name || "-",
      status: {
        label: convertStatus(detail.gadai_detail.status).label,
        color: convertStatus(detail.gadai_detail.status).color,
      },
    },
    summaryInfo: {
      finalEstimatedPrice:
        `Rp ${CurrencyFormat(detail.gadai_detail.valuation_amount) || 0}` ||
        "-",
      tenor:
        `${detail.gadai_detail.tenor_days} hari (${Math.floor(
          detail.gadai_detail.tenor_days / 30
        )} bulan)` || "-",
      loanAmount:
        `Rp ${CurrencyFormat(detail.gadai_detail.loan_amount) || 0}` || "-",
      capitalLoan:
        `Rp ${CurrencyFormat(detail.gadai_detail.capital_loan) || 0}` || "-",
      feeAdmin:
        `Rp ${CurrencyFormat(detail.gadai_detail.fee_admin) || 0}` || "-",
      feeTransfer:
        `Rp ${CurrencyFormat(detail.gadai_detail.fee_transfer) || 0}` || "-",
      feeSavingInsurance:
        `Rp ${CurrencyFormat(detail.gadai_detail.fee_saving_assurance) || 0}` ||
        "-",
      takenAmount:
        `Rp ${CurrencyFormat(detail.gadai_detail.taken_amount) || 0}` || "-",
      remainderLoanAmount:
        `Rp ${CurrencyFormat(detail.gadai_detail.remainder_loan_amount) || 0
        }` || "-",
      sbgPicture: detail.gadai_detail.form_gadai_picture ? (
        <Button
          onClick={handleOpenPreview(
            `gadai/${detail.gadai_detail.id}/form-gadai-picture`
          )}
          type="link"
          style={{ padding: 0 }}
        >
          Lihat Foto Surat Bukti Gadai
        </Button>
      ) : (
        "-"
      ),
      offerName: (
        <div
          style={{ display: "flex", gap: "5px" }}
          onClick={handleOpenCampignDetail}
        >
          <div>{detail?.gadai_promo_loan?.name || "-"}</div>
          <AiFillEye
            style={{ fontSize: 24, color: "#2C465C", cursor: "pointer" }}
          />
        </div>
      ),
    },
    insuranceInfo: getInsuranceInfo(detail, handleOpenPreview),
    valuationInfo: getValuationInfo(detail),
    pictureInfo: {
      productPictures: detail?.gadai_pictures?.product_pictures?.map((pic) => {
        return {
          id: pic?.id || null,
        };
      }),
      storagePictures: {
        officerName: detail?.gadai_product_detail?.officer_name || "-",
        storedDate: formatDate(detail?.gadai_storage?.time_in) || "-",
        notes: detail.gadai_storage.notes || "-",
        pictures: detail?.gadai_pictures?.storage_pictures?.map((pic) => {
          return {
            id: pic?.id || null,
          };
        }),
      },
    },
    summaryTableInfo: detail?.transaction?.map((trans) => {
      return {
        midtransId: trans.midtrans_transaction_id || "-",
        transactionID: trans.id || "-",
        dateTime: formatDate(trans.created_at) || "-",
        transactionType: trans.type || "-",
        transactionMethod: trans.method || "-",
        amount: `Rp ${CurrencyFormat(trans.total) || 0}` || "-",
        financeTrxId: trans?.finance_transaction_id,
        voucher: trans?.voucher || '-',
        transactionProof: trans.transfer_proof_picture ? (
          <Button
            onClick={handleOpenPreview(
              `gadai-transfer/${trans?.gadai_transfer_id}/proof-picture`
            )}
            type="link"
            style={{ padding: 0 }}
          >
            Lihat Bukti Transaksi
          </Button>
        ) : (
          "-"
        ),
        status: trans.status || "-",
      };
    }),
    offer: {
      name: detail?.gadai_promo_loan?.name,
      gadaiType:
        detail?.gadai_promo_loan?.gadai_type === "pick_up"
          ? "Jemput Gadai"
          : "Reguler",
      category: detail?.gadai_promo_loan?.promo_loan?.promo_loan_products
        .map((e) => {
          return e.product_category.name;
        })
        .join(", "),
      outlet:
        detail?.gadai_promo_loan?.gadai_type !== "pick_up"
          ? detail?.gadai_promo_loan?.promo_loan?.promo_loan_outlets
            .map((e) => {
              return e.outlet.name;
            })
            .join(", ")
          : "-",
      tenorType: detail?.gadai_promo_loan?.tenor_type || '',
      paymentType:
        detail?.gadai_promo_loan?.payment_type === "balloon_payment"
          ? "Balloon Payment"
          : "Installment",
      tenor: detail?.gadai_promo_loan?.promo_loan?.promo_loan_tenors
        .map((e) => {
          return `${e.days} Hari`;
        })
        .join(", "),
      minLoan:
        detail?.gadai_promo_loan?.min_loan_rupiah != 0
          ? "Rp " + detail?.gadai_promo_loan?.min_loan_rupiah
          : detail?.gadai_promo_loan?.min_loan_percentage + "%",
      maxLoan:
        detail?.gadai_promo_loan?.max_loan_rupiah != 0
          ? "Rp " + detail?.gadai_promo_loan?.max_loan_rupiah
          : detail?.gadai_promo_loan?.max_loan_percentage + "%",
      capitalLoan:
        detail?.gadai_promo_loan?.capital_loan_rupiah != 0
          ? "Rp " + detail?.gadai_promo_loan?.capital_loan_rupiah
          : detail?.gadai_promo_loan?.capital_loan_percentage + "%",
      feeAdmin:
        detail?.gadai_promo_loan?.fee_admin_rupiah != 0
          ? "Rp " + detail?.gadai_promo_loan?.fee_admin_rupiah
          : detail?.gadai_promo_loan?.fee_admin_percentage + "%",
      feeSavingInsurance:
        detail?.gadai_promo_loan?.fee_saving_assurance_rupiah != 0
          ? "Rp " + detail?.gadai_promo_loan?.fee_saving_assurance_rupiah
          : detail?.gadai_promo_loan?.fee_saving_assurance_percentage + "%",
      feeLateCharge:
        detail?.gadai_promo_loan?.late_charge_rupiah != 0
          ? "Rp " + detail?.gadai_promo_loan?.late_charge_rupiah
          : detail?.gadai_promo_loan?.late_charge_percentage + "%",
      feeLatePeriod:
        detail?.gadai_promo_loan.late_charge_period_rupiah != 0
          ? "Rp " + detail?.gadai_promo_loan.late_charge_period_rupiah
          : detail?.gadai_promo_loan.late_charge_period_percentage + "%",
      feeLateStorage:
        detail?.gadai_promo_loan?.fee_storage_rupiah != 0
          ? "Rp " + detail?.gadai_promo_loan?.fee_storage_rupiah
          : detail?.gadai_promo_loan?.fee_storage_percentage + "%",
      feeAuction:
        detail?.gadai_promo_loan?.fee_auction_rupiah != 0
          ? "Rp " + detail?.gadai_promo_loan?.fee_auction_rupiah
          : detail?.gadai_promo_loan?.fee_auction_percentage + "%",
      maxExtend: detail?.gadai_promo_loan?.max_extension + " Hari",
      maxLate: detail?.gadai_promo_loan?.max_late + " Hari",
      gracePeriod: detail?.gadai_promo_loan?.grace_period + " Hari",
      type: "loan",
    },
    extensions: detail?.gadai_extension,
    installment: getInstallment(detail),
    voucher: detail?.gadai_voucher || [],
  };
  return convertedGadaiDetail;
};

const sumTotalInstallment = (detail, item) => {
  let total = {}
  if (detail.gadai_promo_loan.promo_loan.interest_expense_type === 'behind') {
    total = {
      currency: `Rp ${CurrencyFormat(item.installment_amount + item.late_charge_days + item.late_charge_period + item.capital_loan + detail.gadai_detail.fee_admin + detail.gadai_detail.fee_saving_assurance)}`,
      number: item.installment_amount + item.late_charge_days + item.late_charge_period + item.capital_loan + detail.gadai_detail.fee_admin + detail.gadai_detail.fee_saving_assurance
    }
  } else if (detail.gadai_promo_loan.promo_loan.interest_expense_type === 'behind_new') {
    total = {
      currency: `Rp ${CurrencyFormat(item.installment_amount + item.late_charge_days + item.late_charge_period + item.capital_loan)}`,
      number: item.installment_amount + item.late_charge_days + item.late_charge_period + item.capital_loan
    }
  } else {
    total = {
      currency: `Rp ${CurrencyFormat(item.installment_amount + item.late_charge_days + item.late_charge_period)}`,
      number: item.installment_amount + item.late_charge_days + item.late_charge_period
    }
  }

  return total
}

const getInstallment = (detail) => {
  let installment = []
  detail.gadai_installments && detail.gadai_installments.length > 0 &&
    detail.gadai_installments.map((item) => {
      let start = moment(item.begin_date).format('YYYY-MM-DD HH:mm:ss')
      let end = moment(item.due_date).format('YYYY-MM-DD HH:mm:ss')

      installment.push(
        {
          installmentId: item.id,
          isCurrentPeriod: moment().isBefore(end) && moment().isAfter(start) && item.status !== 'done' && item.status !== 'waiting-ongoing' && item.status !== 'payment-failed',
          isPeriodBeforeToday: moment().isAfter(end) && item.status !== 'done' && item.status !== 'waiting-ongoing' && item.status !== 'payment-failed',
          isPeriodAfterToday: item.status === 'waiting-ongoing',
          interestType: detail.gadai_promo_loan.promo_loan.interest_expense_type,
          periodNumber: item.period_number,
          periode: `${moment(item.begin_date).format('DD/MM/YYYY')} - ${moment(item.due_date).format('DD/MM/YYYY')}`,
          installmentAmount: `Rp ${CurrencyFormat(item.installment_amount) || 0}` || "-",
          lateDays: `Rp ${CurrencyFormat(item.late_charge_days) || 0}` || "-",
          latePeriod: `Rp ${CurrencyFormat(item.late_charge_period) || 0}` || "-",
          status: {
            label: convertStatusInstallment(item.status).label,
            color: convertStatusInstallment(item.status).color,
            status: item.status,
          },
          capitalLoan: `Rp ${CurrencyFormat(item.capital_loan) || 0}` || "-",
          feeAdmin: `Rp ${CurrencyFormat(detail.gadai_detail.fee_admin) || 0}` || "-",
          feeSavingInsurance: `Rp ${CurrencyFormat(detail.gadai_detail.fee_saving_assurance) || 0}` || "-",
          totalBill: sumTotalInstallment(detail, item)?.currency,
          totalBillRaw: sumTotalInstallment(detail, item)?.number,
          voucher: getVoucher(detail, item.id)
        })
    })
  return installment
}

const getVoucher = (data, id) => {
  let voucher = {}
  data.gadai_voucher.map(item => {
    if (item.gadai_installment_id === id) {
      voucher = {
        name: item.voucher_name,
        amount: item.voucher_amount,
        amountCurrency: `Rp ${CurrencyFormat(item.voucher_amount) || 0}` || "-",
        isUsed: JSON.stringify(item.used_date) == 'null' ? false : true
      }
    }
  })
  return voucher
}

const getInsuranceInfo = (detail, handleOpenPreview) => {
  const tempCategory = detail.gadai_detail.product_category.toLowerCase();
  if (tempCategory === "smartphone") {
    return {
      storedPlace: detail.gadai_detail.product_location || "-",
      officerName: detail.gadai_product_detail.officer_name || "-",
      brandName: detail.gadai_product_detail.brand_name || "-",
      modelName: detail.gadai_product_detail.model_name || "-",
      imeiNumber: detail.gadai_product_detail.imei_number || "-",
    };
  } else if (tempCategory === "car" || tempCategory === "bike") {
    let bpkb_picture = [];
    detail.gadai_product_detail.bpkb_pictures.map((item) => {
      return (bpkb_picture = [
        ...bpkb_picture,
        {
          pictureURL: `gadai-bpkb-picture/${item?.id}/picture`,
        },
      ]);
    });
    return {
      storedPlace: detail.gadai_detail.product_location || "-",
      officerName: detail.gadai_product_detail.officer_name || "-",
      stnkPicture: detail.gadai_product_detail.stnk_picture ? (
        <Button
          onClick={handleOpenPreview(
            tempCategory === "car"
              ? `gadai-car/${detail?.gadai_detail?.id}/stnk-picture`
              : tempCategory === "bike"
                ? `gadai-bike/${detail?.gadai_detail?.id}/stnk-picture`
                : ""
          )}
          type="link"
          style={{ padding: 0 }}
        >
          Lihat Foto STNK
        </Button>
      ) : (
        "-"
      ),
      bpkbPicture:
        detail.gadai_product_detail.bpkb_pictures.length !== 0 ? (
          <Button
            onClick={handleOpenPreview(bpkb_picture)}
            type="link"
            style={{ padding: 0 }}
          >
            Lihat Foto BPKB
          </Button>
        ) : (
          "-"
        ),
      vehicleNumber: detail.gadai_product_detail.vehicle_number || "-",
      bpkbNumber: detail.gadai_product_detail.bpkb_number || "-",
      stnkOwnerName: detail.gadai_product_detail.stnk_owner_name || "-",
      stnkOwnerAddress: detail.gadai_product_detail.stnk_owner_address || "-",
      type: (tempCategory === "car" ? "Mobil" : "Sepeda Motor") || "-",
      brandName: detail.gadai_product_detail.brand_name || "-",
      typeName: detail.gadai_product_detail.type_name || "-",
      modelName: detail.gadai_product_detail.model_name || "-",
      year: detail.gadai_product_detail.year || "-",
      transmission: detail.gadai_product_detail.transmission || "-",
      rangkaNumber: detail.gadai_product_detail.rangka_number || "-",
      machineNumber: detail.gadai_product_detail.machine_number || "-",
      colour: detail.gadai_product_detail.colour || "-",
    };
  } else if (tempCategory === "bpkb") {
    return {
      type: (tempCategory === "bpkb" ? "BPKB Kendaraan" : "") || "-",
      stnkPicture: detail.gadai_product_detail.stnk_picture ? (
        <Button
          onClick={handleOpenPreview(
            `gadai-bpkb/${detail?.gadai_detail?.id}/stnk-picture`
          )}
          type="link"
          style={{ padding: 0 }}
        >
          Lihat Foto STNK
        </Button>
      ) : (
        "-"
      ),
      vehicleNumber: detail.gadai_product_detail.vehicle_number || "-",
      bpkbNumber: detail.gadai_product_detail.bpkb_number || "-",
      brandName: detail.gadai_product_detail.brand_name || "-",
      typeName: detail.gadai_product_detail.type_name || "-",
      modelName: detail.gadai_product_detail.model_name || "-",
      year: detail.gadai_product_detail.year || "-",
      transmission: detail.gadai_product_detail.transmission || "-",
      rangkaNumber: detail.gadai_product_detail.rangka_number || "-",
      machineNumber: detail.gadai_product_detail.machine_number || "-",
    };
  } else if (tempCategory === "other") {
    return {
      type: (tempCategory === "other" ? "Gadai Eksklusif" : "") || "-",
      storedPlace: detail.gadai_detail.product_location || "-",
      officerName: detail.gadai_product_detail.officer_name || "-",
    };
  }
  return null;
};

const getValuationInfo = (detail) => {
  const tempCategory = detail.gadai_detail.product_category.toLowerCase();
  if (tempCategory === "smartphone") {
    return {
      finalEstimatedPrice:
        `Rp ${CurrencyFormat(detail.gadai_detail.valuation_amount) || 0}` ||
        "-",
      frontCondition: detail.gadai_valuation.front_condition || "-",
      backCondition: detail.gadai_valuation.back_condition || "-",
      screenCondition: detail.gadai_valuation.screen_condition || "-",
      functionalTest: detail.gadai_valuation.functional_test || "-",
    };
  } else if (tempCategory === "car" || tempCategory === "bike") {
    return {
      valuationAmount:
        `Rp ${CurrencyFormat(detail.gadai_detail.valuation_amount) || 0}` ||
        "-",
      valuationData: detail?.gadai_valuation?.gadai_valuation_data.map(
        (valuation) => ({
          label: valuation.question,
          value: valuation.answer,
        })
      ),
    };
  } else if (tempCategory === "bpkb") {
    return {
      stnkCondition: detail.gadai_valuation.stnk_condition || "-",
      vehicleCondition: detail.gadai_valuation.vehicle_condition || "-",
    };
  } else if (tempCategory === "other") {
    return {
      finalEstimatedPrice:
        `Rp ${CurrencyFormat(detail.gadai_detail.valuation_amount) || 0}` ||
        "-",
      name: detail?.gadai_product_detail?.name,
      detail: detail?.gadai_product_detail?.detail,
      condition: detail?.gadai_product_detail?.detail,
      notes: detail?.gadai_product_detail?.notes,
    };
  }
  return null;
};
